/**
 * "Dein Fahrzeug"-OE-Box auf Lochkreis-Kollektionsseiten. Liest die Werte,
 * die der Fitment-Konfigurator (fitment-configurator.js, doLookup()) vor dem
 * Redirect in sessionStorage abgelegt hat — Shopify-Liquid kann keine
 * beliebigen URL-Parameter lesen, daher der Umweg ueber sessionStorage statt
 * Query-String. Zeigt sich NUR, wenn die gespeicherten Werte zur aktuell
 * angezeigten Kollektion passen (collectionSlug === data-collection-handle),
 * sonst bleibt die Box leer/versteckt — verhindert falsche Fahrzeugdaten,
 * falls der Kunde manuell zu einer anderen Kollektion navigiert.
 */
(function () {
  "use strict";

  function esc(s) {
    var div = document.createElement("div");
    div.textContent = s == null ? "" : String(s);
    return div.innerHTML;
  }

  // Groesse aus rimWidth/rimDiameter aufbauen statt nur den rohen "rim"-String
  // zu zeigen — die ET (rimOffset) wird dadurch ein eigener, klar
  // beschrifteter Wert statt in "7.5Jx17 ET44" unterzugehen. Traglast-/
  // Geschwindigkeitsindex (z. B. "110T") haengt sich an den Reifen an, weil
  // er zur Reifengroesse gehoert, nicht zur Felge.
  function formatSide(side) {
    if (!side) return null;
    var sizeLabel = side.rim || "";
    if (side.rimWidth != null && side.rimDiameter != null) {
      sizeLabel = side.rimWidth + "J x " + side.rimDiameter;
    }
    var etLabel = side.rimOffset != null ? "ET " + side.rimOffset : "";
    var tireLabel = side.tire || "";
    if (tireLabel && side.loadIndex != null && side.speedIndex) {
      tireLabel += " " + side.loadIndex + side.speedIndex;
    }
    return { sizeLabel: sizeLabel, etLabel: etLabel, tireLabel: tireLabel };
  }

  function wheelRowHtml(formatted, axleLabel, flags) {
    var flagsHtml = flags.length
      ? '<span class="zr-fit-oe__wheel-flags">' + esc(flags.join(" · ")) + "</span>"
      : "";
    var tireHtml = formatted.tireLabel
      ? '<span class="zr-fit-oe__wheel-tire">' + esc(formatted.tireLabel) + "</span>"
      : "";
    return (
      '<li class="zr-fit-oe__wheel-row">' +
      (axleLabel ? '<span class="zr-fit-oe__wheel-axle">' + esc(axleLabel) + "</span>" : "") +
      '<span class="zr-fit-oe__wheel-size">' +
      esc(formatted.sizeLabel) +
      "</span>" +
      (formatted.etLabel ? '<span class="zr-fit-oe__wheel-et">' + esc(formatted.etLabel) + "</span>" : "") +
      tireHtml +
      flagsHtml +
      "</li>"
    );
  }

  function render(box, data) {
    var specs = [];
    if (data.boltPattern) specs.push(["Lochkreis", data.boltPattern]);
    // Nur die absolute Ausnahme: eine von vorne ABWEICHENDE Hinterachse
    // (manche Transporter/Kleinbusse) — sonst waere der Wert redundant zu
    // "Lochkreis" oben.
    if (data.rearBoltPattern) specs.push(["Lochkreis hinten", data.rearBoltPattern]);
    if (data.centreBoreMm) specs.push(["Nabenbohrung", data.centreBoreMm + " mm"]);
    if (data.threadSize) specs.push(["Gewinde", data.threadSize]);
    if (data.tighteningTorque) specs.push(["Anzugsmoment", data.tighteningTorque]);

    var specsHtml = specs
      .map(function (s) {
        return (
          '<div class="zr-fit-oe__spec"><span class="zr-fit-oe__spec-k">' +
          esc(s[0]) +
          '</span><span class="zr-fit-oe__spec-v">' +
          esc(s[1]) +
          "</span></div>"
        );
      })
      .join("");

    var wheelsHtml = "";
    if (data.stockWheels && data.stockWheels.length) {
      var rows = data.stockWheels
        .map(function (w) {
          var flags = [];
          if (w.isRecommendedForWinter) flags.push("Winterreifen empfohlen");
          if (w.isRunflatTires) flags.push("Runflat");
          if (w.isExtraLoadTires) flags.push("XL");

          var front = formatSide(w.front);
          var rear = formatSide(w.rear);
          if (!front) return "";
          // Staggered-Fitment (abweichende Hinterachse, z. B. viele
          // Performance-Modelle): beide Achsen einzeln zeigen statt nur die
          // Vorderachse — sonst waere die Hinterachsgroesse fuer den Kunden
          // unsichtbar.
          if (rear) {
            return wheelRowHtml(front, "VA", flags) + wheelRowHtml(rear, "HA", flags);
          }
          return wheelRowHtml(front, "", flags);
        })
        .join("");
      wheelsHtml =
        '<div class="zr-fit-oe__wheels"><span class="zr-fit-oe__wheels-label">Werksbereifung ab Werk</span><ul class="zr-fit-oe__wheels-list">' +
        rows +
        "</ul></div>";
    }

    var vehicleLabel = data.vehicle || "";
    if (vehicleLabel && data.enginePowerPs) {
      vehicleLabel += " · " + data.enginePowerPs + " PS";
    }

    box.innerHTML =
      '<div class="zr-fit-oe__head">' +
      '<span class="zr-fit-oe__eyebrow">Dein Fahrzeug</span>' +
      '<button type="button" class="zr-fit-oe__reset" data-zr-fit-oe-reset>Fahrzeug ändern</button>' +
      "</div>" +
      (vehicleLabel ? '<p class="zr-fit-oe__vehicle">' + esc(vehicleLabel) + "</p>" : "") +
      '<div class="zr-fit-oe__specs">' +
      specsHtml +
      "</div>" +
      wheelsHtml;

    box.hidden = false;

    box.querySelector("[data-zr-fit-oe-reset]").addEventListener("click", function () {
      try {
        sessionStorage.removeItem("zr_fitment");
        sessionStorage.removeItem("zr_fitment_upsteps");
      } catch (e) {
        // ignore
      }
      // Nur die Box zu leeren liesse den Kunden ohne Konfigurator auf der
      // Kollektionsseite zurueck - "Fahrzeug aendern" fuehrt deshalb zurueck
      // zur Startseite, wo der Fitment-Konfigurator im Hero-Slider laeuft.
      window.location.href = "/";
    });
  }

  // "245/70 R 16" -> {sectionWidth: 245, aspectRatio: 70}. Nur der einfache
  // metrische Fall — Sonderformate (LT-Reifen, 82-Series etc.) werden bewusst
  // NICHT geraten, weil eine falsche Annahme hier eine unsichere Kombination
  // als "sicher" ausgeben wuerde.
  function parseTireSize(tireRaw) {
    if (!tireRaw) return null;
    var m = String(tireRaw).match(/^(\d{2,3})\s*\/\s*(\d{2,3})\s*R/i);
    if (!m) return null;
    return { sectionWidth: parseInt(m[1], 10), aspectRatio: parseInt(m[2], 10) };
  }

  // "16 ⨯ 7J" (wheel-size.com nutzt ein Sonderzeichen, kein simples "x") ->
  // {diameter: 16, width: 7}. Robuster als auf das Trennzeichen zu matchen:
  // einfach die ersten beiden Zahlen im String nehmen.
  function parseUpstepRim(rimRaw) {
    var nums = String(rimRaw || "").match(/\d+(\.\d+)?/g);
    if (!nums || nums.length < 2) return null;
    return { diameter: parseFloat(nums[0]), width: parseFloat(nums[1]) };
  }

  /**
   * Reduziert die u. U. 30+ Treffer von /upsteps/ auf den besten (kleinste
   * Abrollumfang-Abweichung) Treffer je NEUEM Zoll — Werks-Durchmesser sind
   * ausgeschlossen (stehen schon unter "Werksbereifung ab Werk"), und nur
   * Kombinationen innerhalb einer ueblichen Sicherheitstoleranz (<= 3,5 %
   * Abrollumfang) zaehlen als "sichere Aufruestung".
   */
  function curateUpsteps(upsteps, oeDiameters) {
    var TOLERANCE_PCT = 3.5;
    var byDiameter = {};
    (upsteps || []).forEach(function (u) {
      if (u.isOe) return;
      var rim = parseUpstepRim(u.rim);
      if (!rim) return;
      if (oeDiameters.indexOf(rim.diameter) !== -1) return;
      if (Math.abs(u.overallDiameterDeltaPct) > TOLERANCE_PCT) return;
      var existing = byDiameter[rim.diameter];
      if (!existing || Math.abs(u.overallDiameterDeltaPct) < Math.abs(existing.deltaPct)) {
        byDiameter[rim.diameter] = {
          diameter: rim.diameter,
          width: rim.width,
          tire: String(u.tire || "").replace(/\s+/g, ""),
          deltaPct: u.overallDiameterDeltaPct,
        };
      }
    });
    return Object.keys(byDiameter)
      .map(function (k) {
        return byDiameter[k];
      })
      .sort(function (a, b) {
        return a.diameter - b.diameter;
      })
      .slice(0, 4);
  }

  function upstepsHtml(items) {
    if (!items.length) return "";
    var rows = items
      .map(function (it) {
        var deltaLabel = (it.deltaPct >= 0 ? "+" : "") + Math.round(it.deltaPct * 10) / 10 + "%";
        return (
          '<li class="zr-fit-oe__upstep-row">' +
          '<span class="zr-fit-oe__upstep-size">' +
          esc(it.width + "J x " + it.diameter) +
          "</span>" +
          '<span class="zr-fit-oe__upstep-tire">' +
          esc(it.tire) +
          "</span>" +
          '<span class="zr-fit-oe__upstep-delta">Abrollumfang ' +
          esc(deltaLabel) +
          "</span>" +
          "</li>"
        );
      })
      .join("");
    return (
      '<div class="zr-fit-oe__upsteps"><span class="zr-fit-oe__upsteps-label">Sichere Aufrüstung (bester Treffer je Zoll)</span><ul class="zr-fit-oe__upsteps-list">' +
      rows +
      '</ul><p class="zr-fit-oe__upsteps-note">Nur eine Abrollumfang-Berechnung — Freigängigkeit, Traglast und Unterlagen der konkreten Variante bitte vor dem Kauf prüfen.</p></div>'
    );
  }

  /**
   * Ergaenzt die schon gerenderte Box um Aufruestungs-Optionen — eigener,
   * spaeter Request, weil /upsteps/ laut TOS nicht gecacht werden darf und
   * pro Seitenaufruf der wichtigsten Werksgroesse genuegt (keine Anfrage je
   * Werksrad-Zeile).
   */
  /**
   * /upsteps/ darf laut TOS nicht serverseitig gecacht werden (siehe
   * wheel-size.client.ts) — das heisst aber nicht "bei jedem Seitenaufruf neu
   * abfragen". Ohne diesen Cache feuert appendUpsteps() bei UNVERAENDERTEM
   * Fahrzeug bei JEDER Navigation (Kollektion -> Produkt -> naechstes Produkt
   * -> zurueck ...) einen frischen Request — reine Verschwendung des
   * gemeinsamen Tageskontingents. Dieselbe Begruendung wie beim zr_fitment-
   * sessionStorage selbst: reines, session-lokales Echo EINES bereits
   * abgerufenen Ergebnisses fuer denselben Nutzer, kein serverseitiges
   * Caching, verschwindet mit dem Tab.
   */
  function upstepsCacheKey(primary, size) {
    return [primary.rimDiameter, primary.rimWidth, primary.rimOffset, size.sectionWidth, size.aspectRatio].join("|");
  }

  function readUpstepsCache(key) {
    var raw;
    try {
      raw = sessionStorage.getItem("zr_fitment_upsteps");
    } catch (e) {
      return null;
    }
    if (!raw) return null;
    try {
      var cached = JSON.parse(raw);
      return cached && cached.key === key ? cached.curated : null;
    } catch (e) {
      return null;
    }
  }

  function writeUpstepsCache(key, curated) {
    try {
      sessionStorage.setItem("zr_fitment_upsteps", JSON.stringify({ key: key, curated: curated }));
    } catch (e) {
      // Privater Modus / Speicher voll etc. — beim naechsten Mal wird einfach neu geholt.
    }
  }

  function appendUpsteps(box, data) {
    var apiBase = box.dataset.apiBase;
    if (!apiBase) return;
    var primary = data.stockWheels && data.stockWheels[0] && data.stockWheels[0].front;
    if (!primary) return;
    var size = parseTireSize(primary.tire);
    if (!size || primary.rimDiameter == null || primary.rimWidth == null || primary.rimOffset == null) return;

    var key = upstepsCacheKey(primary, size);
    var cached = readUpstepsCache(key);
    if (cached) {
      var cachedHtml = upstepsHtml(cached);
      if (cachedHtml) box.insertAdjacentHTML("beforeend", cachedHtml);
      return;
    }

    var oeDiameters = [];
    (data.stockWheels || []).forEach(function (w) {
      [w.front, w.rear].forEach(function (side) {
        if (side && side.rimDiameter != null && oeDiameters.indexOf(side.rimDiameter) === -1) {
          oeDiameters.push(side.rimDiameter);
        }
      });
    });

    var url = new URL(apiBase.replace(/\/$/, "") + "/api/fitment/upsteps");
    url.searchParams.set("rimDiameter", primary.rimDiameter);
    url.searchParams.set("rimWidth", primary.rimWidth);
    url.searchParams.set("rimOffset", primary.rimOffset);
    url.searchParams.set("sectionWidth", size.sectionWidth);
    url.searchParams.set("aspectRatio", size.aspectRatio);

    fetch(url.toString())
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (upsteps) {
        if (!upsteps || !upsteps.length) return;
        var curated = curateUpsteps(upsteps, oeDiameters);
        writeUpstepsCache(key, curated);
        var html = upstepsHtml(curated);
        if (html) box.insertAdjacentHTML("beforeend", html);
      })
      .catch(function () {
        // Aufruestungs-Vorschlaege sind ein Zusatz, kein kritischer Pfad.
      });
  }

  function init() {
    var box = document.querySelector("[data-zr-fitment-oe]");
    if (!box) return;

    var raw;
    try {
      raw = sessionStorage.getItem("zr_fitment");
    } catch (e) {
      return;
    }
    if (!raw) return;

    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!data || !data.collectionSlug) return;
    if (data.collectionSlug !== box.dataset.collectionHandle) return;
    // Aelterer sessionStorage-Eintrag (Kunde hat das Fahrzeug in einem Tab
    // gewaehlt, der noch vor einem Deploy offen war) hat eine andere
    // stockWheels-Form (front/rear statt flach) — lieber gar nichts zeigen
    // als eine Box mit leerer "Werksbereifung ab Werk"-Liste.
    if (data.schemaVersion !== 2) return;

    render(box, data);
    appendUpsteps(box, data);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
